import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: "",
        headerCellStyle: {background: '#F5F7FA', color: '#606266'},
    },
    getters: {
        user(state) {
            if (!state.user.token) {
                if (!sessionStorage.user) {
                    return "";
                } else {
                    state.user = JSON.parse(sessionStorage.user);
                }
            }
            return state.user;
        },
        isLogin() {
            return sessionStorage.getItem('user') ? true : false;
        },


    },
    mutations: {
        /**
         * 登录
         * @param state
         * @param user
         */
        login(state, user) {
            if (user) {
                sessionStorage.setItem("token", user.token);
                sessionStorage.setItem("user", JSON.stringify(user));
            }
        },
        /**
         * 登出
         * @param state
         * @param user
         */
        logout(state) {
            sessionStorage.clear();
            state.user = "";
            // userRequest.loginOut();
            window.location.reload();
        },
        /**
         * 更新User
         * @param state
         */
        updateUser(state) {
            state.user = JSON.parse(sessionStorage.user);
        },
    },
    actions: {},
    modules: {

    }
})



//////////////////
// WEBPACK FOOTER
// ./src/store/all.store.js
// module id = p9Ur
// module chunks = 10